import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { logo } from 'utils/common/clientStyleAssets';
import 'app/modules/Header/Header.scss';
import { withTranslation } from 'react-i18next';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown } from 'react-bootstrap';
import http from 'api/http-request';
import queryString from 'query-string';
import i18n from 'i18n';
import { sanitizeUrl } from '@braintree/sanitize-url';
import Cookies from 'js-cookie';
import ReactGA from 'react-ga';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectURL: '',
      loginPageUrl: '',
    };
  }

  getCTSession = () => {
    if (Cookies.get('ctsessionlanguage')) {
      if (
        Cookies.get('ctsessionlanguage') === 'en_US' ||
        Cookies.get('ctsessionlanguage') === 'undefined'
      ) {
        this.changeLanguage('en_US');
      } else {
        this.changeLanguage('es');
      }
    }
  };
  setDefaultLanguage = () => {
    localStorage.setItem('ctsessionlanguage', 'en_US');
    Cookies.set('ctsessionlanguage', 'en_US');
  };

  componentDidMount = () => {
    this.getCTSession();
    if (Cookies.get('DeviceUsed') == 'mobile') {
      this.setState({
        redirectURL: '/profile/DashboardMobile',
        loginPageUrl: '/mobile',
      });
    } else if (Cookies.get('dashboardRequired') == 'customWallet') {
      this.setState({
        redirectURL: '/profile/Dashboard',
        loginPageUrl: '/customwallet',
      });
    } else {
      this.setState({
        redirectURL: '/profile/Dashboard',
        loginPageUrl: '/',
      });
    }
  };

  getAPIHeaders = () => {
    return {
      'Content-Type': 'application/x-www-form-urlencoded',
    };
  };

  deleteStorageAPI = (e) => {
    e.preventDefault();

    let iPlanetDirectoryPro = Cookies.get('iPlanetDirectoryPro');
    http(
      {
        url: 'logoff',
        method: 'POST',
        data: { iPlanetDirectoryPro: iPlanetDirectoryPro },
      },
      {
        'Content-Type': 'application/json',
      }
    ).then(() => {
      ReactGA.event({
        category: 'Logout',
        action: 'Logout: Logout Button triggered from Header Component',
      });
      Cookies.remove('user_id');
      Cookies.remove('dataStoreToken');
      Cookies.remove('profileCodeDetails');
      Cookies.set('userLoggedIn', false);
      Cookies.remove('idToken');
      Cookies.remove('clientId');
      Cookies.remove('userDetails');
      Cookies.remove('firstName');
      Cookies.remove('lastName');
      Cookies.remove('isUserLogin');
      Cookies.remove('admin');
      Cookies.remove('roles');
      Cookies.remove('username');
      Cookies.remove('walletRegistered');
      Cookies.remove('preferredLanguage');
      Cookies.remove('idProofingStatus');
      Cookies.remove('firstLoginSession');
      Cookies.remove('ctsessionlanguage');
      Cookies.remove('iPlanetDirectoryPro', { domain: '.aegis-frk.com' });
      localStorage.removeItem('isIdProofing');
      //this.getCTSession();
      ReactGA.event({
        category: 'Logout',
        action: 'Logout: Logout-Success',
      });
      this.setDefaultLanguage();

      if (Cookies.get('loginType') == 'uniLogin') {
        Cookies.remove('loginType');
        window.location.href =
          'https://digitalwallet-dev.deloitte.com/unilogin/logout';

      } else {
        window.location.href = sanitizeUrl(this.state.loginPageUrl);
      }
    });
  };

  changeLanguage = (lang) => {
    Cookies.set('ctsessionlanguage', lang);

    i18n.changeLanguage(lang);
  };

  render() {
    let iPlanetDirectoryPro = Cookies.get('iPlanetDirectoryPro');
    const { t, userDetails } = this.props;
    const userInitials = `${
      userDetails.givenName ? userDetails.givenName.charAt(0) : ''
    }${userDetails.sn ? userDetails.sn.charAt(0) : ''}`;

    const userDetailsEmpty = Object.keys(userDetails).length === 0;
    return (
      <div className="header d-flex align-items-center">
        <a
          className="my-0 mr-auto"
          href={
            iPlanetDirectoryPro != undefined
              ? this.state.redirectURL
              : this.state.loginPageUrl
          }
        >
          <img
            src={logo}
            alt="logo"
            className="w-100"
            style={{ height: '5rem' }}
          />
        </a>
        <Dropdown className="m-0 translation" tabIndex="0">
          <Dropdown.Toggle id="dropdownButton" as={Button}>
            <p className="user-initials-icon bold p-4 m-0">
              {Cookies.get('ctsessionlanguage') === undefined ||
              Cookies.get('ctsessionlanguage') === 'en_US' ||
              Cookies.get('ctsessionlanguage') === null
                ? t('pages.header.english')
                : t('pages.header.spanish')}
            </p>
          </Dropdown.Toggle>
          <Dropdown.Menu tabIndex="0">
            <Dropdown.Item
              to="#"
              as={Link}
              onClick={() => {
                this.changeLanguage('en_US');
              }}
            >
              {t('pages.header.english')}
            </Dropdown.Item>
            <Dropdown.Item
              to="#"
              as={Link}
              onClick={() => {
                this.changeLanguage('es');
              }}
            >
              {t('pages.header.spanish')}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        {!userDetailsEmpty && userInitials && (
          <nav
            className="my-2 my-md-0 ml-3 mr-sm-3"
            id="user-Initials-container"
            role="navigation"
            aria-label="user navigation"
          >
            <Dropdown className="m-0 b-0">
              <Dropdown.Toggle as={Button}>
                <p className="user-initials-icon bold p-3 m-0 ">
                  {userInitials}
                </p>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <p className="welcome-text">
                  {t('pages.header.welcome')},{' '}
                  <span className="bold">
                    {userDetails.givenName} {userDetails.sn}
                  </span>
                </p>
                <Dropdown.Item
                  href="#"
                  onClick={(e) => {
                    this.deleteStorageAPI(e);
                  }}
                >
                  <span className="pr-2">
                    <FontAwesomeIcon
                      icon={faSignOutAlt}
                      role="img"
                    ></FontAwesomeIcon>
                  </span>
                  {t('pages.header.dropdownLogout')}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </nav>
        )}
      </div>
    );
  }
}

Header.propTypes = {
  t: PropTypes.func.isRequired,
  userDetails: PropTypes.object,
  history: PropTypes.object,
};
Header.defaultProps = {
  userDetails: {},
};

export default withTranslation()(Header);
